// extracted by mini-css-extract-plugin
export default {"counter":"counter_counter__zfcVv","decrement":"counter_decrement__v0jho","increment":"counter_increment__rmL+Y","count":"counter_count__gm0+w"};